import * as React from 'react';
export const warningCircleSvg = React.forwardRef(function warningCircleSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.142 3.74a.867.867 0 1 1 1.717 0l-.287 2.005a.577.577 0 0 1-1.142 0L5.142 3.74ZM7 8a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 6A6 6 0 1 1 0 6a6 6 0 0 1 6-6c3.322 0 6 2.686 6 6Zm-1.4 0A4.6 4.6 0 1 1 6 1.4c2.548 0 4.6 2.058 4.6 4.6Z',
    }),
  );
});
warningCircleSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var warningCircle = {
  category: 'icon',
  colorable: true,
  name: 'warningCircle',
  svg: warningCircleSvg,
};
